<template>
  <div class="container-page-pois">
    <div class="container-table-pois">
      <div v-for="(tipes, index) in Pois" :key="index" class="table-pois" :class="'table-pois-' + (index + 1)">
        <dataList :id="tipes.tipo.replaceAll(' ', '')" :key="index" class="" :title="$t(tipes.tipo_literal)">
          <dataRow v-for="(pois, index2) in tipes.pois" :key="pois.name + '-' + index + '-' + index2">
            <div slot="col-title">{{ pois.name }}</div>
            <div slot="col-value">{{ pois.distance }} m</div>
          </dataRow>
        </dataList>
      </div>
    </div>
  </div>
</template>

<script>
import dataList from '@/components/designComponents/dataList'
import dataRow from '@/components/designComponents/dataRow'

export default {
  name: 'PagePois',
  components: { dataList, dataRow },
  props: {
    Pois: {
      default: null
    }
  },
  data() {
    return {}
  },
  computed: {},
  methods: {}
}
</script>

<style lang="scss" scoped>
.container-page-pois {
  width: 100%;
  height: 100%;

  .container-table-pois {
    width: 100%;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    flex-direction: column;
    align-items: center;

    .table-pois {
      width: 33%;
    }

  }
}
</style>
